module.exports = __webpack_public_path__ + "static/USFlag-1ac818e5dcc9bcd34e00ab8b464263dd.png";